export const cssVariablesLight = {
  "--tg-theme-hint-color": "#999999",
  "--tg-theme-secondary-bg-color": "#efeff3",
  "--tg-theme-text-color": "#000000",
  "--memo-text-color-disabled": "#808080",
  "--tg-theme-button-color": "#2481cc",
  "--memo-button-color-alpha-20": "#2481cc33",
  "--memo-action-tile-active": "#5f687317",
  "--memo-button-color-alpha-40": "#2481cc66",
  "--memo-button-color-darkened": "#1c66a1",
  "--memo-color-review-repeat": "#f59e0b",
  "--memo-color-review-new": "#22c55e",
  "--tg-theme-bg-color": "#ffffff",
  "--tg-theme-button-text-color": "#ffffff",
  "--tg-theme-link-color": "#2481cc",
};

export const cssVariablesDark = {
  "--tg-theme-hint-color": "#b1c3d5",
  "--tg-theme-secondary-bg-color": "#131415",
  "--tg-theme-text-color": "#ffffff",
  "--memo-text-color-disabled": "#92a3b3",
  "--tg-theme-button-color": "#2ea6ff",
  "--memo-button-color-alpha-20": "#2ea6ff33",
  "--memo-action-tile-active": "#2ea6ff33",
  "--memo-button-color-alpha-40": "#2ea6ff66",
  "--memo-button-color-darkened": "#0090fa",
  "--memo-color-review-repeat": "#fde047",
  "--memo-color-review-new": "#86efac",
  "--tg-theme-bg-color": "#18222d",
  "--tg-theme-button-text-color": "#ffffff",
  "--tg-theme-link-color": "#62bcf9",
};
